import IconSetting from '@hapana/shared/web/styles/assets/svgs/setting.svg'
import IconMapMarker from '@hapana/shared/web/styles/assets/svgs/map-marker.svg'
import IconPlayCircle from '@hapana/shared/web/styles/assets/svgs/play-circle.svg'
import IconFileGraph from '@hapana/shared/web/styles/assets/svgs/file-graph.svg'
import UsersIcon from '@hapana/shared/web/styles/assets/svgs/users.svg'
import IconHome from '@hapana/shared/web/styles/assets/svgs/home.svg'
import i18n from '@hapana/shared/web/i18n'

import { ROUTES } from '../../app.constants'

export const settingsNavItems = {
  settings: {
    name: i18n.t('common:navigationLinks.settings'),
    icon: IconSetting,
    to: ROUTES.settings.path,
    key: 'settings',
  },
  locationSettings: {
    name: i18n.t('common:navigationLinks.locationSettings'),
    icon: IconMapMarker,
    to: ROUTES.settings.children.locationSettings.path,
    key: 'location-settings',
  },
  schedulerSettings: {
    name: i18n.t('common:navigationLinks.schedulerSettings'),
    icon: IconPlayCircle,
    to: ROUTES.settings.children.schedulerSettings.path,
    key: 'scheduler-settings',
  },
  retailSettings: {
    name: i18n.t('common:navigationLinks.retailSettings'),
    icon: IconFileGraph,
    to: ROUTES.settings.children.retailSettings.path,
    key: 'retail-settings',
  },
  accountSettings: {
    name: i18n.t('common:navigationLinks.accountSettings'),
    icon: UsersIcon,
    to: ROUTES.settings.children.accountSettings.path,
    key: 'account-settings',
  },
  userProfile: {
    name: i18n.t('common:navigationLinks.userProfile'),
    to: ROUTES.userProfile.path,
    key: 'user-profile',
  },
}

export const SETTINGS_BOTTOM_NAVIGATIONS = {
  withoutLocation: {
    main: [
      {
        icon: IconHome,
        id: 'dashboard',
        label: i18n.t('common:navigationLinks.backToDashboard'),
        href: ROUTES.dashboard.path,
      },
    ],
  },
  withLocation: {
    bottomNavItems: [
      {
        icon: IconHome,
        id: 'dashboard',
        label: i18n.t('common:navigationLinks.backToDashboard'),
        href: ROUTES.dashboard.path,
      },
    ],
    main: [
      {
        icon: IconHome,
        id: 'dashboard',
        label: i18n.t('common:navigationLinks.backToDashboard'),
        href: ROUTES.dashboard.path,
      },
    ],
    bottomDefault: [
      {
        id: 'dashboard',
        label: i18n.t('common:navigationLinks.backToDashboard'),
        icon: IconHome,
        href: ROUTES.dashboard.path,
      },
    ],
    userProfile: {
      id: 'profile',
      label: i18n.t('common:navigationLinks.myProfile'),
      route: 'profile',
      alt: i18n.t('common:navigationLinks.userProfileAlt'),
    },
  },
}

export const SETTINGS_ROUTES = [
  ROUTES.settings.path,
  ROUTES.settings.children.locationSettings.path,
  ROUTES.settings.children.locationSettings.children.roomResourceConfiguration.path,
  ROUTES.settings.children.locationSettings.children.siteCommunicationTemplates.path,
  ROUTES.settings.children.schedulerSettings.path,
  ROUTES.settings.children.retailSettings.path,
  ROUTES.settings.children.accountSettings.path,
  ROUTES.userProfile.path,
]
